<template>
  <div>
    <v-card tile>
      <v-list class="py-0" color="secondary">
        <v-list-item-group v-model="items">
          <v-list-item
            :key="i"
            class="my-0"
            color="secondary"
            rounded
            text
            v-for="(link, i) in items"
          >
            <a :href="link.url">
              <v-list-item-content>
                <v-card
                  class="white--text"
                  color="primary lighten-1"
                  max-width="600"
                >
                  <v-card-title primary-title>
                    <div class="headline">
                      {{ link.title }}
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout>
                      <v-flex xs2>
                        <v-img
                          :src="link.img"
                          contain
                          height="125px"
                          v-if="link.img"
                        ></v-img>
                        <v-img
                          contain
                          height="125px"
                          src="@/assets/logo.png"
                          v-else
                        ></v-img>
                      </v-flex>
                      <v-flex xs10>
                        <span
                          >Gepubliceerd op {{ link.date_year }}-{{
                            link.date_month
                          }}-{{ link.date_day }}.</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn dark text>Read</v-btn>
                  </v-card-actions>
                </v-card>
              </v-list-item-content>
            </a>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "NewsPage",
  data() {
    return {
      items: [
        {
          date_year: "2020",
          date_month: "3",
          date_day: "20",
          img: "",
          url:
            "https://www.gfcnieuws.com/wovs-chinese-winkeliers-verworden-tot-zwarte-schapen/",
          title: "WOVS: Chinese winkeliers verworden tot zwarte schapen"
        },
        {
          date_year: "2020",
          date_month: "3",
          date_day: "19",
          img:
            "https://www.srherald.com/wp-content/uploads/2020/03/d94ffe0d-cd4a-d5bf-0cd9-f6506082d45e-768x432.jpg",
          url:
            "https://www.srherald.com/ingezonden/2020/03/19/winkeliers-en-vermeende-prijsopdrijving/",
          title: "Winkeliers en vermeende prijsopdrijving"
        },
        {
          date_year: "2020",
          date_month: "3",
          date_day: "19",
          img:
            "https://www.srnieuws.com/media/wovs-bijt-van-zich-af-in-gesprek-met-minister-tsang-168.jpg",
          url:
            "https://www.srnieuws.com/suriname/284443/wovs-bijt-van-zich-af-in-gesprek-met-minister-tsang/",
          title: "WOVS bijt van zich af in gesprek met minister Tsang"
        },
        {
          date_year: "2020",
          date_month: "3",
          date_day: "18",
          img: "",
          url:
            "https://www.gfcnieuws.com/tsang-roept-winkeliers-op-om-deuren-open-te-houden/",
          title: "HI&T praat met SCUA en WOVS over oplossingsmodellen"
        },
        {
          date_year: "2020",
          date_month: "2",
          date_day: "14",
          img:
            "https://www.srherald.com/wp-content/uploads/2020/02/1eb1bb61.jpg",
          url:
            "https://www.srherald.com/suriname/2020/02/14/wovs-onverantwoorde-prijsverhogingen-moeten-teruggedraaid-worden/",
          title:
            'WOVS: "Onverantwoorde prijsverhogingen moeten teruggedraaid worden"'
        },
        {
          date_year: "2020",
          date_month: "2",
          date_day: "14",
          img:
            "https://www.gfcnieuws.com/wp-content/uploads/2020/02/tsang-hit.jpg",
          url:
            "https://www.gfcnieuws.com/hit-bespreekt-vermoedelijke-prijsverhoging-chinese-puntjes-met-bakkers/",
          title: "Tsang roept winkeliers op om deuren open te houden"
        },
        {
          date_year: "2020",
          date_month: "2",
          date_day: "13",
          img:
            "https://www.gfcnieuws.com/wp-content/uploads/2020/02/tsnag-bakkers.jpg",
          url:
            "https://www.gfcnieuws.com/hit-praat-met-scua-en-wovs-over-oplossingsmodellen/",
          title:
            "HI&T bespreekt vermoedelijke prijsverhoging ‘Chinese puntjes’ met bakkers"
        },
        {
          date_year: "2020",
          date_month: "1",
          date_day: "17",
          img:
            "https://www.gfcnieuws.com/wp-content/uploads/2020/02/tsnag-bakkers.jpg",
          url:
            "https://www.gfcnieuws.com/winkeliersverenigingen-geinformeerd-over-basisgoederen-plus-project/",
          title:
            "Winkeliersverenigingen geïnformeerd over Basisgoederen Plus project"
        },
        {
          date_year: "2020",
          date_month: "6",
          date_day: "6",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/58999",
          title: "WOVS: Niet winkeliers maar leveranciers verhogen prijzen"
        },
        {
          date_year: "2020",
          date_month: "6",
          date_day: "5",
          url:
            "https://www.youtube.com/watch?v=DI_kqTsyhMM&fbclid=IwAR3rHNcGMufz35dpURdBglobKnEieEN8NuS1SZMsAj9wHpVlOX3_3ImUE08",
          title:
            "Meer dan de hleft van de supermarkten zijn dicht STVS JOURNAAL 5 juni 2020"
        },
        {
          date_year: "2020",
          date_month: "6",
          date_day: "4",
          url:
            "https://www.youtube.com/watch?v=eXVDX_p_ni4&fbclid=IwAR1lAwlL2_6xVF4qq1939oD69LmcV4egd94Ud3GZXc6ofaaP1Muv93_HwDk",
          title:
            "Consumentenkring keurt gedrag winkeliers af STVS JOURNAAL 4 juni 2020"
        },
        {
          date_year: "2020",
          date_month: "6",
          date_day: "4",
          url:
            "https://www.srherald.com/suriname/2020/06/04/wovs-garandeert-openhouden-winkels-tijdens-total-lockdown/",
          title: "WOVS garandeert openhouden winkels tijdens total-lockdown"
        },
        {
          date_year: "2020",
          date_month: "6",
          date_day: "4",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/58970",
          title: "Schappen in winkels raken leeg; winkeliers bekaf"
        },
        {
          date_year: "2020",
          date_month: "6",
          date_day: "4",
          url:
            "https://sun.sr/Details/2625_Jqe1dOOaGtsQa9JZ9v2unkWK0ugJUILUwEC3KcSGORSUGzwi2JDR5k7NXsSyWKLtmtnn42CscQLMiMFaf7DpuQcFcFccFcFc_lege.jpg?fbclid=IwAR0citJG_T9N3UvVGuptvR02OcaZri7xlu1EJgfNg1u4cLNJ8nfz1EIP71I",
          title: "Handelaren verhogen prijzen, lege rekken en winkeldiefstal"
        },
        {
          date_year: "2020",
          date_month: "6",
          date_day: "2",
          url:
            "https://sun.sr/Details/2592_0V2fwvw08hp514WDExx32naLIPIDa4yXgmXkwDSognmJgRtL8EVaFaFa5fd9l0GCQHojIuNBMJHbFbFbFeettfmaV1oqrQcFcFccFcFc_wovss.jpg?fbclid=IwAR0citJG_T9N3UvVGuptvR02OcaZri7xlu1EJgfNg1u4cLNJ8nfz1EIP71I",
          title: "WOVS: Winkeliers verkopen vanuit luikjes of tralies"
        },
        {
          date_year: "2020",
          date_month: "3",
          date_day: "19",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/57621",
          title: "WOVS bijt van zich af in gesprek met minister Tsang"
        },
        {
          date_year: "2020",
          date_month: "2",
          date_day: "14",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/57056",
          title: "'Chinese puntjes' niet duurder geworden"
        },
        {
          date_year: "2018",
          date_month: "7",
          date_day: "4",
          url:
            "https://www.dbsuriname.com/2018/07/04/wovs-afvloeiing-personeel-niet-uitgesloten-bij-verhoging-minimumuurloon/",
          title:
            "WOVS “Afvloeiing personeel niet uitgesloten bij verhoging minimumloon"
        },
        {
          date_year: "2017",
          date_month: "6",
          date_day: "23",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/42011",
          title: "Project 'Leefbaarheid & Veiligheid' voor preventie misdaad"
        },
        {
          date_year: "2017",
          date_month: "4",
          date_day: "20",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/40955",
          title: "WOVS: Geen Wild-west-situatie"
        },
        {
          date_year: "2016",
          date_month: "12",
          date_day: "21",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/38948",
          title: "Dos Ramos geeft beveiligingstips: de do & don’ts"
        },
        {
          date_year: "2016",
          date_month: "12",
          date_day: "20",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/38937",
          title: "Ondernemers krijgen voorlichting KBS"
        },
        {
          date_year: "2016",
          date_month: "11",
          date_day: "1",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/38140",
          title: "Wisselkoers US-dollar blijft stijgen"
        },
        {
          date_year: "2016",
          date_month: "10",
          date_day: "28",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/38084",
          title: "WOVS: Verruwing gedrag klanten naar winkeliers verergert"
        },
        {
          date_year: "2016",
          date_month: "10",
          date_day: "18",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/37932",
          title: "Reactie WOVS op bericht Consumentenkring"
        },
        {
          date_year: "2016",
          date_month: "9",
          date_day: "16",
          url:
            "https://www.srherald.com/suriname/2016/09/16/wovs-criminaliteit-baart-winkeliers-en-ondernemers-zorgen/",
          title: "WOVS: Criminaliteit baart winkeliers en ondernemers zorgen"
        },
        {
          date_year: "2016",
          date_month: "8",
          date_day: "18",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/36984",
          title: "WOVS bespreekt prijsaanpassingen winkeliers met HI"
        },
        {
          date_year: "2016",
          date_month: "8",
          date_day: "15",
          url:
            "http://www.srherald.com/suriname/2016/08/15/discussiedag-moet-problemen-wovs-leden-verminderen/",
          title: "Discussiedag moet problemen WOVS leden verminderen"
        },
        {
          date_year: "2016",
          date_month: "8",
          date_day: "15",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/36939",
          title: "WOVS bezorgd over effecten loslaten douanekoers"
        },
        {
          date_year: "2016",
          date_month: "6",
          date_day: "18",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/35960",
          title: "Dinsdag behandeling Stabilisatie- en Herstelplan"
        },
        {
          date_year: "2016",
          date_month: "6",
          date_day: "16",
          url:
            "http://www.srherald.com/suriname/2016/06/16/chinese-en-surinaamse-ondernemers-willen-meer-informatie/",
          title: "Chinese en Surinaamse ondernemers willen meer informatie"
        },
        {
          date_year: "2016",
          date_month: "6",
          date_day: "15",
          url:
            "http://www.srherald.com/suriname/2016/06/15/wovs-hield-informatiesessie-voor-haar-leden/",
          title: "WOVS hield informatiesessie voor haar leden"
        },
        {
          date_year: "2016",
          date_month: "5",
          date_day: "12",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/35283",
          title: "WOVS steunt actie niet, leden zijn vrij"
        },
        {
          date_year: "2016",
          date_month: "5",
          date_day: "4",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/35120",
          title: "Hoge stroomtarieven fataal voor kleine ondernemers"
        },
        {
          date_year: "2016",
          date_month: "5",
          date_day: "2",
          url:
            "http://www.dbsuriname.com/dbsuriname/index.php/winkels-sluiten-bij-de-vleet/",
          title: "Winkels sluiten bij de vleet"
        },
        {
          date_year: "2016",
          date_month: "4",
          date_day: "30",
          url:
            "http://www.dbsuriname.com/dbsuriname/index.php/wovs-winkeliers-makkelijke-slachtoffers-voor-rovers/",
          title: "WOVS: Winkeliers makkelijke slachtoffers voor rovers"
        },
        {
          date_year: "2016",
          date_month: "4",
          date_day: "28",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/35000",
          title: "WOVS: Winkeliers Albina boycotten bedrijven niet"
        },
        {
          date_year: "2016",
          date_month: "4",
          date_day: "25",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/34962",
          title: "WOVS weerspreekt kartelvorming tegen SuriSmiles"
        },
        {
          date_year: "2016",
          date_month: "4",
          date_day: "7",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/34634",
          title: "Zijn de kleine winkeliers de boosdoeners?"
        },
        {
          date_year: "2016",
          date_month: "3",
          date_day: "27",
          url:
            "https://www.starnieuws.com/index.php/welcome/index/nieuwsitem/34463",
          title: "Winkeliers en ondernemers willen behoud kleinhandel"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
